import styled from 'styled-components';
import { Colors, FontSize, Spacing } from '../../../assets/GlobalStyle/Variables';

export const ListContainer = styled.div`
  padding-top: ${Spacing(4)};
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing(4)};
  margin-bottom: ${Spacing(6)};
`;

export const FilterLabel = styled.label`
  white-space: nowrap;
  font-size: ${FontSize.normal};
  color: ${Colors.grey};
  font-weight: 600;
  min-width: 140px;
`;

export const FilterSelectWrapper = styled.div`
  width: 300px;
`;

export const TableCard = styled.div`
  background: ${Colors.white};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

export const StyledTable = styled.table`
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
`;

export const StyledTableHead = styled.thead`
  background-color: ${Colors.lightBackground};
  border: 1px solid #cde0ee;
  height: 50px;
  vertical-align: middle;

  th {
    border-right: 1px solid ${Colors.lightGrey};
    padding: ${Spacing(2)} ${Spacing(4)};
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
  }
`;

export const StyledTableBody = styled.tbody<{ $hasData?: boolean }>`
  border-left: 1px solid ${Colors.lightGrey};

  tr {
    height: 40px;
    border-bottom: 1px solid ${Colors.lightGrey};
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: ${Colors.lightBackground};
    }

    &.active {
      background-color: #e8f0fe;
    }
  }

  td {
    border-right: 1px solid ${Colors.lightGrey};
    padding: ${Spacing(1)} ${Spacing(4)};
    white-space: nowrap;
  }
`;

export const EmptyTableRow = styled.tr`
  cursor: default !important;

  &:hover {
    background-color: transparent !important;
  }

  td {
    padding: ${Spacing(6)} ${Spacing(4)} !important;
    color: ${Colors.grey};
    font-style: italic;
    text-align: center;
    cursor: default;
  }
`;

export const RightPanelCard = styled.div`
  background: ${Colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow-y: auto;
  max-height: calc(100vh - 200px);
`;

export const RightPanelEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: ${Colors.grey};
  font-style: italic;
  font-size: ${FontSize.normal};
  border: 1px dashed ${Colors.lightGrey};
  border-radius: 8px;
`;

export const ReadOnlyOverlay = styled.div`
  pointer-events: none;
  user-select: none;
  opacity: 0.8;
`;

export const PrintButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
`;

export const PrintButton = styled.button`
  background-color: transparent;
  color: ${Colors.primary};
  border: 1px solid ${Colors.primary};
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: ${Colors.primary};
    color: #fff;
  }
`;
